import { atom } from 'jotai';
import { atomFamily, atomWithStorage, createJSONStorage } from 'jotai/utils';

const sessionStore = createJSONStorage<boolean>(() => sessionStorage);

/** Whether the IFC spatial tree drawer is open. */
export const fragmentTreeOpenAtom = atomWithStorage<boolean>(
  '@actegon.gis.fragmentTree.open',
  false,
  sessionStore,
);

/**
 * Set of localIds that the user has explicitly hidden, per modelId
 * (`frag-<layerId>`). Lives in-memory only — visibility is a transient
 * UI state, not something we want to persist across sessions.
 */
export const fragmentHiddenIdsAtom = atomFamily((_modelId: string) =>
  atom<Set<number>>(new Set<number>()),
);
